import React from 'react'
import bootstrapScopedStyles from './../../styles/bootstrapScoped.min.module.css'
import OnfsButton from '../button/OnfsButton'
import OnfsHeader from '../header/OnfsHeader'
import { normalModalStyle, smallModalStyle } from './modalStyles'
import Modal from 'react-modal'

export default function OnfsModal({
  title,
  isOpen,
  setIsOpen,
  children,
  size = 'normal',
  ...rest
}) {
  const modalStyle =
    size.toLowerCase() === 'small' ? smallModalStyle : normalModalStyle

  return (
    <div className={bootstrapScopedStyles['bootstrap-scope']}>
      <Modal
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => setIsOpen(false)}
        style={modalStyle}
        contentLabel={title}
        {...rest}
      >
        <div className={bootstrapScopedStyles['container-fluid']}>
          <div className={bootstrapScopedStyles.row}>
            <OnfsHeader
              className={bootstrapScopedStyles.col}
              label={title}
              level='h1'
              size='md'
            />

            <div className={bootstrapScopedStyles['col-1']}>
              <OnfsButton
                link
                aria-label={'Close ' + title + ' Modal'}
                onClick={() => setIsOpen(false)}
                label={<span aria-hidden='true'>&times;</span>}
                style={{
                  position: 'absolute',
                  top: '1.25rem',
                  right: '1.25rem',
                  fontSize: 'xx-large'
                }}
              />
            </div>
          </div>
          {children}
        </div>
      </Modal>
    </div>
  )
}
